import { Component, OnInit } from '@angular/core';
import { AuditService } from 'app/services/audit.service';

@Component({
    selector: 'app-audit-report',
    templateUrl: './audit-report.component.html',
    styleUrls: ['./audit-report.component.scss']
  })
  export class AuditReportComponent implements OnInit {
    constructor(
        public auditService: AuditService,
      ) {}
    
      ngOnInit() {
        //    this.log.trace('admin home loaded');
      }
      generateOrganizationAuditReport() {
        this.auditService.downloadAuditReport();
      }
  }